<template>
  <div class="custom-tab mt-2">
    <div class="tab-wrapper">
      <b-tabs
        class="custom-qtap"
        justified
        ref="bTabs"
        :no-nav-style="true"
        :nav-class="navContainerClass"
        @activate-tab="handleInnerTabActivated"
        :value="activeTab"
        @input="onTabChange"
      >
        <slot />
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { BTabs } from 'bootstrap-vue';
export default {
  name: 'QTab',
  components: {
    BTabs,
  },
  props: {
    navClass: {
      type: String,
      default: () => '',
    },
    tabActivated: {
      type: Function,
      default: () => {},
    },
    activeTab: {
      type: Number,
      default: () => null,
    },
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(newVal) {
        if (newVal) this.tabModel = newVal;
      },
    },
    tabModel: {
      immediate: true,
      handler(newVal, oldVal) {
        if (oldVal != newVal) {
          this.$emit('input', newVal);
        }
      },
    },
  },
  data() {
    return {
      tabModel: null,
      theme: {},
    };
  },
  computed: {
    navContainerClass() {
      return `custom-tab-container ${this.navClass}`;
    },
  },
  methods: {
    onTabChange(newTab) {
      this.tabModel = newTab;
      this.$emit('change', newTab, this.activeTab);
    },
    scrollTo(scrollPixels) {
      let element = this.$el.querySelector('.custom-tab-container');
      const scrollPos = element.scrollLeft;
      element.scrollLeft = scrollPos + scrollPixels;
    },
    setActiveTabByTabindex(tabindex) {
      const tabToActivate = this.$refs.bTabs?.$children.find(
        (x) => x.tabindex == tabindex
      );
      if (!tabToActivate) return;

      const innerIndex = this.$refs.bTabs.$children.indexOf(tabToActivate);

      this.tabModel = innerIndex;
    },
    handleInnerTabActivated(newTab, oldTab, event) {
      this.$emit('before-change', newTab, oldTab, event);

      if (!this.tabActivated) {
        return;
      }

      this.tabActivated(
        this.$refs.bTabs?.$children[newTab].tabindex,
        this.$refs.bTabs?.$children[oldTab].tabindex,
        event
      );
    },
  },
};
</script>

<style scoped lang="scss">
.custom-tab {
  --tab-border-color: #e2e2e2;
  --nav-link-color: #11291b;
  --tab-active-color: white;
  --tab-font-size: 14px;
  display: flex;
  align-items: flex-start;

  &-cursors {
    display: none;
    cursor: pointer;
    color: var(--tab-active-color);
    margin-top: 20px !important;

    @media only screen and (max-width: 768px) {
      display: block;
    }

    &.nav-left-icon {
      margin-right: 10px;
    }
    &.nav-right-icon {
      margin-left: 10px !important;
    }
  }

  .tabs {
    flex-grow: 1;
  }

  .tab-wrapper {
    flex-grow: 1;
    width: 80%;
  }

  ::v-deep .custom-qtap > div:first-child {
    border-bottom: unset !important;

    @media only screen and (max-width: 768px) {
      display: inline-block;
      margin: 0 0 1em;
      white-space: nowrap;
      width: 100%;
      overflow: auto;
      overflow-y: hidden;
    }

    .nav-item {
      @media only screen and (max-width: 768px) {
        display: inline-block !important;
        width: auto;
      }

      padding: 18px 18px 0px 18px;
      flex-direction: column;
      align-items: center;
      gap: 7px;
      flex: 1 0 0;
      background: var(--background-medium-gray, #f2f2f2);
      margin-right: 4px;

      &:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }

      &:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }

      &:has(.active) {
        background: var(--color-palette-secondary, #ff7058) !important;
      }

      .nav-link {
        font-size: var(--tab-font-size);
        color: var(--nav-link-color);
        padding: 0px 0px 18px 0px;

        &.active {
          color: var(--tab-active-color);
          font-weight: bold;
          border-bottom: unset !important;

          &::after {
            left: 47% !important;
            border-left: 0.6rem solid transparent !important;
            border-right: 0.6rem solid transparent !important;
            border-bottom: 0.6rem solid white !important;
          }
        }

        @media only screen and (max-width: 768px) {
          font-size: 12px;
          padding-bottom: 10px;
          padding-right: 27px !important;
          width: 100%;
        }
      }
    }
  }
}
</style>
